/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ region: NonNullable<unknown>, intensity: NonNullable<unknown> }} Coach_Context_Injury_CurrentInputs */

const en_us2_coach_context_injury_current = /** @type {(inputs: Coach_Context_Injury_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: ${i?.intensity} pain`)
};

const pt_br2_coach_context_injury_current = /** @type {(inputs: Coach_Context_Injury_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dor ${i?.intensity}`)
};

const es_419_coach_context_injury_current = /** @type {(inputs: Coach_Context_Injury_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dolor ${i?.intensity}`)
};

const pt_pt2_coach_context_injury_current = /** @type {(inputs: Coach_Context_Injury_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dor ${i?.intensity}`)
};

const fr_fr2_coach_context_injury_current = /** @type {(inputs: Coach_Context_Injury_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region} : douleur ${i?.intensity}`)
};

const de_de2_coach_context_injury_current = /** @type {(inputs: Coach_Context_Injury_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: Schmerzen (${i?.intensity})`)
};

const it_it2_coach_context_injury_current = /** @type {(inputs: Coach_Context_Injury_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: dolore ${i?.intensity}`)
};

/**
* | output |
* | --- |
* | "{region}: {intensity} pain" |
*
* @param {Coach_Context_Injury_CurrentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_context_injury_current = /** @type {((inputs: Coach_Context_Injury_CurrentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Context_Injury_CurrentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_context_injury_current(inputs)
	if (locale === "es-419") return es_419_coach_context_injury_current(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_context_injury_current(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_context_injury_current(inputs)
	if (locale === "de-DE") return de_de2_coach_context_injury_current(inputs)
	if (locale === "it-IT") return it_it2_coach_context_injury_current(inputs)
	return en_us2_coach_context_injury_current(inputs)
});
export { coach_context_injury_current as "coach.context_injury_current" }